/* eslint-disable no-prototype-builtins */
/* eslint-disable no-underscore-dangle */

const freeze = (object, property, value) => {
  Object.defineProperty(object, property, {
    configurable: true,
    get() { return value; },
    set(v) { console.warn(`tried to set frozen property ${property} with ${v}`); },
  });
};

function makeKey(key, id) {
  return `${key}_fragmentChild_${id}`;
}

export default {
  abstract: true,
  name: 'Fragment',

  props: {
    name: {
      type: String,
      default: () => Math.floor(Date.now() * Math.random()).toString(16),
    },
    html: {
      type: String,
      default: null,
    },
  },

  mounted() {
    const container = this.$el;
    const parent = container.parentNode;

    container.__isFragment = true;
    container.__isMounted = false;

    const head = document.createComment(`fragment#${this.name}#head`);
    const tail = document.createComment(`fragment#${this.name}#tail`);

    container.__head = head;
    container.__tail = tail;

    // use document fragment to improve efficiency
    const tpl = document.createDocumentFragment();
    tpl.appendChild(head);

    Array.from(container.childNodes)
      .forEach((node) => {
        // container.appendChild(node, true)
        const notFrChild = !node.hasOwnProperty('__isFragmentChild__');
        tpl.appendChild(node);
        if (notFrChild) {
          freeze(node, 'parentNode', container);
          freeze(node, '__isFragmentChild__', true);
        }
      });

    tpl.appendChild(tail);

    // embed html
    if (this.html) {
      const template = document.createElement('template');
      template.innerHTML = this.html;
      // copy elements over
      Array.from(template.content.childNodes).forEach((node) => {
        tpl.appendChild(node);
      });
    }

    const next = container.nextSibling;
    parent.insertBefore(tpl, container, true);
    parent.removeChild(container);
    freeze(container, 'parentNode', parent);
    freeze(container, 'nextSibling', next);
    if (next) { freeze(next, 'previousSibling', container); }

    container.__isMounted = true;
  },

  render(h, ctx = {}) {
    const children = this.$slots.default;

    return h(
      'div',
      { attrs: { fragment: this.name }, ...ctx, key: this.$vnode.key },
      children.map((child, idx) => ({
        ...child,
        data: {
          ...child.data,
          attrs: {
            key: makeKey(
              this.$vnode.key,
              idx,
            ),
            fragment: this.name,
            ...(child.data || {}).attrs,
          },
          key: makeKey(
            this.$vnode.key,
            idx,
          ),
        },
        key: makeKey(
          this.$vnode.key,
          idx,
        ),
      })),
    );
  },
};
